import React from 'react'
import RolesItem from "./RolesItem"

function RolesBody(props) {
    const {listRoles} = props

    return (
        <tbody className="TableBody">
        {
            !!listRoles && listRoles.length > 0 ? listRoles.map((item, index) => (
                <RolesItem key={index} index={index} item={item}/>
            )) : <tr className="NoRecord">
                <td colSpan={3}>Không có bản ghi nào</td>
            </tr>
        }
        </tbody>
    )
}

export default RolesBody
